module.exports = __webpack_public_path__ + "static/media/kakao-map.6db098c3.png";